
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { ResponseType, QueryType } from "@/common/types/common";
import type { MemberPayloadType } from "@/common/types/member";

export async function memberList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/member/list${queryString}`
    );
}

export async function memberGet(
    member_id: string
) {
    return await clientAxios.get(
        `admin/member/${member_id}/show`
    );
}

export async function memberPatch(
    member_id: string,
    payload: Partial<MemberPayloadType>
) {
    return await clientAxios.patch(
        `admin/member/${member_id}/patch`,
        { payload }
    );
}

export async function memberDel(
    member_id: string
) {
    return await clientAxios.del(
        `admin/member/${member_id}/delete`
    );
}

export async function memberRegister(
    payload: any
) {
    return await clientAxios.post(
        `member/register`,
        payload
    );
}
